"use strict";

angular.module("vendor")
.component("productForm", {
    templateUrl: require("./product-form.component.html"),
    controller: ProductFormController,
    controllerAs: "productFormCtrl"
});

function ProductFormController(
    $scope, $rootScope, $stateParams, $filter, $q, common, gettextCatalog, FlashBag, FormError, Language,
    UserService, SupplierUserInfoService, PatternService, ProductCategoriesService, UnitsOfMeasureService,
    BarcodeFormatsService, ProductService, PRODUCT_TYPES
) {
    var _this = this;
    var promises = [];

    $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
    $scope.PRODUCT_QUANTITY_MAX = ProductService.PROCUT_QUANTITY_MAX;

    $scope.showAttachmentButton = false;
    $scope.productService = ProductService;
    $scope.submitButtonDisabled = true;
    $scope.pattern = PatternService;

    $scope.languages = $rootScope.languages;
    $scope.supportedLanguages = Language.getSupportedLanguages();
    Language.initializeScope($scope, "language", "locale");
    $scope.$on("LanguagesFetched", function(evt, languages) {
        $scope.languages = languages;
    });

    $scope.PRODUCT_TYPES = PRODUCT_TYPES;
    $scope.productTypes = ProductService.getProductTypes();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.productTypes = ProductService.getProductTypes();
    });

    $scope.$watch("productForm.$dirty", function(newValue) {
        $scope.hasUnsavedProductChanges = newValue;
    });

    $scope.product = {
        id: $stateParams.id,
        unit_of_measure: 5,
        BarcodeFormat: 1,
        packaging_quantity: 1,
        enabled: true,
        product_type: PRODUCT_TYPES.STANDARD,
        product_variants: [],
        product_deposits: []
    };
    $scope.workflows = [
        {section: "catalogEdit", object: "catalogEntry.product"},
    ];

    $scope.expectedAvailabilityDateOptions = {
        allowInputToggle: true,
        useCurrent: false,
        format: "YYYY-MM-DD",
        sideBySide: true,
        toolbarPlacement: "bottom",
        showClose: true,
        showClear: true,
        icons: {
            close: "fa fa-check"
        }
    };

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user && user.vendor) {
            $scope.enableProductMeasureManagement = user.vendor.enable_product_measure_management;
            $scope.isProductInventoryAvailable = user.vendor.inventory_holder === "product";
            $scope.isCatalogEntryInventoryAvailable = user.vendor.inventory_holder === "catalog_entry";
            $scope.isQuantityConstraintAvailable = user.vendor.quantity_constraint_holder === "product";
            $scope.showSupplierNameField = user.vendor.is_supplier_name_visible;
            $scope.setInventoryQuantityZero = user.vendor.set_quantity_zero_at_inventory_creation;
            $scope.allowProductVariants = user.vendor.allow_product_variants;

            if (!$scope.product.id && $scope.isProductInventoryAvailable && $scope.setInventoryQuantityZero) {
                $scope.product.inventory_quantity = 0;
            }
        }
    });

    SupplierUserInfoService.getManufacturers().then(function onSuccess(response) {
        if (response && response.data && response.data.length) {
            $scope.manufacturers = response.data;
        }
    });

    $scope.ProductCategories = ProductCategoriesService.query();
    $scope.UnitTypesList = UnitsOfMeasureService.query();
    $scope.barcodeFormats = BarcodeFormatsService.query();

    promises.push(
        $scope.UnitTypesList.$promise,
        $scope.barcodeFormats.$promise
    );

    $q.all(promises).then(function() {
        fetchProduct();
        $scope.submitButtonDisabled = false;
    });

    this.selectedBarcodeFormat = function(selectedFormat) {
        $scope.currentBarcodeFormat = $filter("getById")($scope.barcodeFormats, selectedFormat);
        if ($scope.currentBarcodeFormat && !$scope.currentBarcodeFormat.digit_count) {
            $scope.product.UPC = null;
        }
    };

    this.validateCategory = function(selected) {
        return selected.Type === "BRICK";
    };

    this.saveProduct = function() {
        var deferred = $q.defer();
        $scope.productForm.$setSubmitted();
        FlashBag.clearAll();

        if ($scope.productForm.$valid || $scope.productForm.$error.used) {
            var productCopy = angular.copy($scope.product);
            productCopy.variants = JSON.stringify(productCopy.product_variants);
            productCopy.deposits = JSON.stringify(productCopy.product_deposits);
            if (productCopy.expected_availability_date) {
                productCopy.expected_availability_date = moment(productCopy.expected_availability_date).format("YYYY-MM-DD");
            }
            else {
                productCopy.expected_availability_date = null;
            }

            var fileNames = ["ImageFile", "attachment_file"];
            var sendData = common.createFormDataFromFiles(productCopy, fileNames);

            var savePromise;
            if ($scope.product.id) {
                savePromise = ProductService.update($scope.product.id, sendData)
            }
            else {
                savePromise = ProductService.create(sendData);
            }
            savePromise.then(
                function onSuccess(response) {
                    $scope.hasUnsavedProductChanges = false;
                    $scope.productForm.$setPristine();
                    if ($scope.productForm) {
                        $scope.productForm.UPC.$setValidity("used", true);
                    }
                    deferred.resolve(response.data);
                },
                function onError(response) {
                    if ($scope.productForm) {
                        var is_upc_used = !response.data["UPC"];
                        $scope.productForm.UPC.$setValidity("used", is_upc_used);
                    }
                    FormError.focus("productForm");
                    FlashBag.apiError(response);
                    deferred.reject(response);
                }
            );
        }
        else {
            FormError.focus("productForm");
            deferred.reject(true);
        }
        return deferred.promise;
    };

    this.onDeleteAttachment = function() {
        fetchProduct();
    };

    function fetchProduct() {
        if (!$scope.product.id) {
            $scope.showAttachmentButton = true;
            return;
        }

        ProductService.get($scope.product.id).$promise.then(function(data) {
            //Check for bad product ID
            if (!data) {
                FlashBag.preformattedError(gettextCatalog.getString("The requested product was not found."));
                return;
            }

            try {
                $scope.product = data;
                $scope.showAttachmentButton = $scope.product.attachments.length === 0;
                _this.selectedBarcodeFormat($scope.product.BarcodeFormat);
            }
            catch (e) {
                FlashBag.preformattedError("Internal error: " + ((typeof e == "object") && e.message ? e.message : ""));
            }

            $scope.$broadcast("productFetched");
        }, function(response) {
            FlashBag.apiError(response);
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-form/product-form.component.js
// module id = 912
// module chunks = 0